module.exports = __webpack_public_path__ + "static/media/display03.16a0b265.jpg";